// レストラン詳細ページのメニューをすべて見るボタン
$('.js-showRestaurantMenu').on('click', function () {
  var width = $(window).width();
  var bp = 767;

  // PC表示時はflexで表示させる必要あり
  if (width <= bp) {
    $(this).parent().siblings('.is-hidden').fadeIn();
    $(this).hide();
  } else {
    $(this).parent().siblings('.is-hidden').fadeIn().css('display', 'flex');
    $(this).hide();
  }
  return false;
});